module.exports = __webpack_public_path__ + "img/WP2023-Dubai.4bf887cf.jpg";